import { v } from "convex/values"

export const FEATURE_REQUEST_STATUSES = [
  "under_review",
  "planned",
  "in_progress",
  "complete",
] as const

export type FeatureRequestStatus = (typeof FEATURE_REQUEST_STATUSES)[number]

export const FEATURE_REQUEST_STATUS_LABELS: Record<FeatureRequestStatus, string> = {
  under_review: "Under Review",
  planned: "Planned",
  in_progress: "In Progress",
  complete: "Complete",
}

export const featureRequestStatusValidator = v.union(
  v.literal("under_review"),
  v.literal("planned"),
  v.literal("in_progress"),
  v.literal("complete"),
)

export const FEATURE_REQUEST_SORT_OPTIONS = ["votes", "newest"] as const

export type FeatureRequestSortOption = (typeof FEATURE_REQUEST_SORT_OPTIONS)[number]

export const featureRequestSortValidator = v.union(v.literal("votes"), v.literal("newest"))

export const FEATURE_REQUEST_TIMELINE_KINDS = ["comment", "status_update", "merge_notice"] as const

export type FeatureRequestTimelineKind = (typeof FEATURE_REQUEST_TIMELINE_KINDS)[number]

export const featureRequestTimelineKindValidator = v.union(
  v.literal("comment"),
  v.literal("status_update"),
  v.literal("merge_notice"),
)

export const TITLE_MAX_LENGTH = 200
export const DESCRIPTION_MAX_LENGTH = 5000
export const COMMENT_MAX_LENGTH = 5000
export const STATUS_NOTE_MAX_LENGTH = 1000
export const SEARCH_QUERY_MAX_LENGTH = 200
export const MAX_DUPLICATE_SUGGESTIONS = 6
